function fetchItem(metadataId, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/widgets/item/${metadataId}`;
  return apiClient.get(route);
}

export default {
  fetchItem
};



// WEBPACK FOOTER //
// ./app/api/WidgetApi.js